export const ErrorEmailMessage = 'メールアドレスまたはパスワードが違います';
export const ErrorSystemMessage =
  'システムエラーが発生しました。お手数ですが、時間をおいて再度お試しください。';
export const ErrorAuthenticationMessage =
  '認証エラーが発生しました。お手数ですが再度設定をお願いします。';
export const ErrorExpirationDateMessage =
  '有効期限が切れています。お手数ですが再度設定をお願いします。';
export const ErrorSendConfirmMailMessage =
  '登録いただいたメールアドレスに確認メールを送信しています。 メールを確認いただき、添付されているURLからアカウント情報の入力に進んでください。';
